import React from 'react';
import ReactDOM from 'react-dom';

import { install } from 'resize-observer';

import App from './App';

if (typeof window !== 'undefined') {
  install();
}

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root'),
);
